import {ScoreCategory} from "../types/leaderboard";

type CategoryStateMap = Record<ScoreCategory, unknown>;

let weeklyCache: CategoryStateMap | null = null;
let globalCache: CategoryStateMap | null = null;

export function getWeeklyCache<T extends CategoryStateMap>(): T | null {
  return weeklyCache as T | null;
}

export function setWeeklyCache<T extends CategoryStateMap>(state: T): void {
  weeklyCache = state;
}

export function hasWeeklyCache(): boolean {
  return weeklyCache !== null;
}

export function getGlobalCache<T extends CategoryStateMap>(): T | null {
  return globalCache as T | null;
}

export function setGlobalCache<T extends CategoryStateMap>(state: T): void {
  globalCache = state;
}

export function hasGlobalCache(): boolean {
  return globalCache !== null;
}

export function clearAllCaches(): void {
  weeklyCache = null;
  globalCache = null;
}

